import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const storeHoursBulkAccessControlView: DomainAccessControlConfig = {
  permissions: [Permission.WarehouseLocationHoursView],
  restrictedBannersAllowed: true,
}
